/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {
	PADDING_LEFT,
	PADDING_RIGHT
} from "../../../utils/AppDialog";
import {OKButton} from "../../widget/OKButton";
import * as emotion from "emotion";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";

type Props = {
	patientCount?: number
	selectedCount: number
	okText: string
	okEnabled: boolean
	cancelText?: string
	onCancel: () => void
	onOK: () => void
	cancelDisabled?: boolean
	hideNumberOfPatients?: boolean
	extraButton?: React.ReactNode
}

const cancelButton = (disabled: boolean) => emotion.css(
	{
		height: 40,
		width: 160,
		// Center text vertically. Resolved content height == 17.
		lineHeight: '17px',
		textAlign: 'center',
		padding: '10px 11px',
		borderRadius: '4px',
		userSelect: 'none',
		cursor: disabled ? "default" : "pointer",
		border: `1px solid ${COLORS.neutral_gray_1}`,
		boxSizing: 'border-box',
		marginRight: 13
	}
);

export class PatientSelectionButtons
	extends React.Component<Props> {

	render() {
		const patientCount = this.props.patientCount || '0';
		return <div className={'ll_h_c'}
		            style={{
			            paddingLeft: PADDING_LEFT,
			            paddingRight: PADDING_RIGHT,
			            paddingBottom: 32,
			            justifyContent: 'space-between'
		            }}>
			<div style={{fontSize: 14, color: "#6a6b6d", fontWeight: 'normal'}}>
				{this.props.hideNumberOfPatients !== true && this.props.selectedCount + " of " + patientCount}
			</div>
			<div className={`ll_h_c`}>
				<div className={`${cancelButton(!!this.props.cancelDisabled)}`}
				     onClick={() => {
					     if (this.props.cancelDisabled)
						     return;
					     this.props.onCancel();
				     }}>
					{FONTS.reg_16_secondary_dark("Cancel")}
				</div>
				<OKButton
					text={this.props.okText}
					enabled={this.props.okEnabled}
					onClick={this.props.onOK}
				/>
				{this.props.extraButton}
			</div>
		</div>;
	}


}